import * as React from "react";

const SvgComponent = () => (
  <svg width="80.000000" height="80.000000" viewBox="0 0 80 80" fill="none">
    <defs>
      <clipPath id="clip1505_1011">
        <rect id="Frame" width="80.000000" height="80.000000" fill="white" fill-opacity="0" />
      </clipPath>
    </defs>
    <rect id="Frame" width="80.000000" height="80.000000" fill="#FFFFFF" fill-opacity="0" />
    <g clip-path="url(#clip1505_1011)">
      <path
        id="Vector"
        d="M73.3359 70L6.66797 70L6.66797 63.334L10 63.334L10 13.334C10 11.4922 11.4922 10 13.3359 10L60 10C61.8438 10 63.3359 11.4922 63.3359 13.334L63.3359 30L70 30L70 63.334L73.3359 63.334L73.3359 70ZM56.668 63.334L63.3359 63.334L63.3359 36.666L43.3359 36.666L43.3359 63.334L50 63.334L50 43.334L56.668 43.334L56.668 63.334ZM56.668 30L56.668 16.666L16.668 16.666L16.668 63.334L36.668 63.334L36.668 30L56.668 30ZM23.3359 36.666L30 36.666L30 43.334L23.3359 43.334L23.3359 36.666ZM23.3359 50L30 50L30 56.666L23.3359 56.666L23.3359 50ZM23.3359 23.334L30 23.334L30 30L23.3359 30L23.3359 23.334Z"
        fill="#07B3FC"
        fill-opacity="1.000000"
        fill-rule="nonzero"
      />
    </g>
  </svg>
);

export default SvgComponent;
